
/**
 * Handlebars Path Helpers
 * Copyright (c) 2013 Jon Schlinkert, Brian Woodward, contributors
 * Licensed under the MIT License (MIT).
 */
'use strict';
// The module to be exported
var helpers = {

    /**
     * Origin CDN
     * @param {string} cdn - siteParams.env
     * @returns {*|string|string}
     * @description Nucleus assets can't resolve uat CDN, VTIM team uses this helper
     * to resolve the origin cdn.
     */
    originCDN: function(cdn) {
      const prods = [ 'prod1_h_w', 'prod2_h_2'];
      const environments = [ 'dev1_h_w', 'dev2_h_w', 'dev3_h_w', 'dev4_h_w', 'devflex1_h_w', 'sit1a_h_w', 'sit2a_h_w',
        'sit3_h_w', 'sitbc_h_w', 'pssit_h_w', 'preview1_h_w', 'preview2_h_w', 'pt1_h_w', 'pt2_h_w', 'review1_h_w', 'review2_h_w'];

      if (cdn === 'local') return 'http://localhost:4000';
      if (prods.includes(cdn) || cdn.includes('prod')) return 'https://origin-bac-assets.bankofamerica.com';
      if (environments.includes(cdn)) return `https://origin-bac-assets-${cdn.replace('_h_w', '')}-helix.ecnp.bankofamerica.com`;
      return 'https://origin-bac-assets.bankofamerica.com';

    },

    nucleusDevelopment: function(cdn) {
      const prods = [ 'prod1_h_w', 'prod2_h_2'];
      const environments = [ 'dev1_h_w', 'dev2_h_w', 'dev3_h_w', 'dev4_h_w', 'devflex1_h_w', 'sit1a_h_w', 'sit2a_h_w',
        'sit3_h_w', 'sitbc_h_w', 'pssit_h_w', 'preview1_h_w', 'preview2_h_w', 'pt1_h_w', 'pt2_h_w', 'review1_h_w', 'review2_h_w'];

      const nucleusScript = '/nucleus/spa-assets/components/utilities/global/nucleus/1.0.0/js/index.js';
      const nucleusDevelopment = '/nucleus/spa-assets/components/utilities/global/nucleus-development/1.0.0/js/index.js';

      if (cdn === 'local') return `http://localhost:4000${nucleusDevelopment}`;
      if (prods.includes(cdn) || cdn.includes('prod') ) return `https://origin-bac-assets.bankofamerica.com${nucleusScript}`;
      if (environments.includes(cdn)) return `https://origin-bac-assets-${cdn.replace('_h_w', '')}-helix.ecnp.bankofamerica.com${nucleusDevelopment}`;
      return `https://origin-bac-assets.bankofamerica.com${nucleusScript}`;

    },

    requiredAttrsCheck: function(attrs, requiredAttrs) {
        var attr;
        for (var i = 0, len = requiredAttrs.length; i < len; i++) {
            attr = requiredAttrs[i];
            if (attrs[attr] === undefined) {
                return {
                    pass: false,
                    missingField: attr
                };
            }
        }
        return {
            pass: true
        };
    },
    /**
     * @method Handlebars.helpers.orderCSS
     * @description takes array of page CSS, sorts it to desired load order, and returns <link /> tags
     * @param {Array} css array of page CSS paths
     * @param {String} assetPath string defining environment-specific path to assets
     * @returns Handlebars.SafeString
     */
    orderCSS: function(css, assetPath) {
      // initialize empty array for our sorted link tags
      var links = [];

      // define our basic load order sections: vendor utilities, style utility, global utilities, utilities, global modules, modules
      var loadOrder = [
        'utilities/vendor/',
        'utilities/global/sparta-style-utility',
        'utilities/global/',
        'utilities/',
        'modules/global/',
        'modules/'
      ];

      css
        // sort our css array
        .sort(function(a, b) {
          // initialize empty indexes for comparison
          var aIndex = 0;
          var bIndex = 0;

          // iterate through our loadOrder definitions to find the first match for our a element
          loadOrder.some(function(item, index) {
            // when a match is found, save the index
            if (a.indexOf(item) > -1) {
              aIndex = index;

              // exit the Array.prototype.some
              return true;
            }

            // continue iterating
            return false;
          });

          // iterate through our loadOrder definitions to find the first match for our b element
          loadOrder.some(function(item, index) {
            // when a match is found, save the index
            if ( b.indexOf(item) > -1) {
              bIndex = index;

              // exit the Array.prototype.some
              return true;
            }

            // continue iterating
            return false;
          });

          // sort by desired order index
          return aIndex - bIndex;
        })

        // iterate through sorted css array
        .forEach(function(link) {
          // get actual href for link tag
          var href = Handlebars.helpers.pathClean(assetPath, link);

          // add link tag to links array
          links.push('<link rel="stylesheet" type="text/css" href="' + href + '">');
        })
      ;

      // return formatted link tags as string
      return new Handlebars.SafeString(links.join('\n\t'));
    },
    pathClean: function(str1, str2) {
      return (str2.charAt(0) === "/" && str1 === "/") ? str2 : `${str1.replace(/\/+$/, '')}/${str2}`;
    },
    combineAttrs: function(attrs, combinableAttrs) {
        var attrVal;
        for (var attrName in combinableAttrs) {
            attrVal = combinableAttrs[attrName];
            if (attrs[attrName] && attrName === "value") {
                attrs[attrName] += attrVal;
            } else if (attrs[attrName] && attrName) {
                attrs[attrName] += " " + attrVal;
            } else {
                attrs[attrName] = attrVal;
            }
        }
    },
    removeReservedAttrs: function(attrs, reservedAttrs) {
        for (var i = 0, len = reservedAttrs.length; i < len; i++) {
            delete attrs[reservedAttrs[i]];
        }
    },
    buildAttrsString: function(attrs) {
        var str = "",
            attrVal;
        for (var attrName in attrs) {
            attrVal = attrs[attrName];
            str += ' ' + attrName + '=' + ((typeof attrVal === "object") ? "'" + JSON.stringify(attrVal) + "'" : '"' + attrVal + '"');
        }
        return str;
    },

    /**
     * Extend - extend an object
     * @param {object} target - Target object to extend.
     * @param {object} source - Source object you are extending with.
     */
    extend: function(opts, target, source) {
        if (arguments.length < 3) {
            target = arguments[0] || {};
            source = arguments[1] || {};

            opts = {
                extendArray: false
            };
        } else {
            target = target || {};
            source = source || {};
        }

        //iterate through properties and extend them
        for (var prop in source) {
            //if this property is an object
            if (typeof source[prop] === 'object') {
                //if we aren't supposed to extend arrays and this is an array
                if (!opts.extendArray && Array.isArray(source[prop])) {
                    //replace the original array property with the new array property
                    target[prop] = source[prop];
                    //if we are supposed to extend arrays or this isn't an array
                } else {
                    //recursively call this extend method to extend the object as needed
                    target[prop] = Handlebars.helpers.extend(target[prop], source[prop]);
                }
                //if this isn't an object
            } else {
                //replace the property
                target[prop] = source[prop];
            }
        }

        //return the extended object
        return target;
    }
};
// Export helpers
module.exports.register = function(Handlebars, options) {
    options = options || {};
    for (var helper in helpers) {
        if (helpers.hasOwnProperty(helper)) {
            Handlebars.registerHelper(helper, helpers[helper]);
        }
    }
};
module.exports.helpers = helpers;
